import React, { useState } from "react";
import { DayPickerSingleDateController } from "react-dates";
import moment from "moment";
import * as calendarUtils from "../../utils/calendarUtils";

const Calendar = ({
  selectedDates,
  isPreferenzeValid,
  dateNonDisponibili,
  onDateChange,
}) => {
  //Helpers
  const isOutsideRange = (day) => {
    // Return true if date is before today
    if (day.isBefore(moment(), "day")) {
      return true;
    }

    // Return true if date is in the unavailable dates array
    if (dateNonDisponibili && dateNonDisponibili.length > 0) {
      const isUnavailable = dateNonDisponibili.some(
        (dateStr) =>
          moment(dateStr).format("YYYY-MM-DD") === day.format("YYYY-MM-DD")
      );
      if (isUnavailable) return true;
    }

    // // Return true if date is not in the available dates array
    // if (availableDates && availableDates.length > 0) {
    //   const isAvailable = availableDates.some(
    //     (dateStr) =>
    //       moment(dateStr).format("YYYY-MM-DD") === day.format("YYYY-MM-DD")
    //   );
    //   return !isAvailable;
    // }

    return false;
  };

  if (!isPreferenzeValid) {
    return (
      <div>
        <h2>Calendario</h2>
        <p>Per visualizzare il calendario, seleziona prima le preferenze.</p>
      </div>
    );
  }

  return (
    <div>
      <h2>Calendario</h2>
      <h3>Seleziona le giornate per le lezioni</h3>
      <DayPickerSingleDateController
        date={null}
        onDateChange={onDateChange}
        //focused={focused}
        //onFocusChange={({ focused }) => setFocused({ focused })}
        isOutsideRange={isOutsideRange}
        isDayHighlighted={(day) =>
          selectedDates.some((day2) => calendarUtils.isSameDay(day, day2))
        }
        renderDayContents={(day) => {
          const isHighlighted = selectedDates.some((day2) =>
            calendarUtils.isSameDay(day, day2)
          );
          return (
            <div
              style={{
                borderRadius: "0%",
                background: isHighlighted ? "#2185d0" : undefined,
                color: isHighlighted ? "#fff" : undefined,
                width: "32px",
                height: "32px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "auto",
              }}
            >
              {day.date()}
            </div>
          );
        }}
        numberOfMonths={2}
        hideKeyboardShortcutsPanel={true}
      />
    </div>
  );
};

export default Calendar;
